import {
  LeftOutlined,
  MenuOutlined
} from '@ant-design/icons';

import { Button, Divider, Flex, Image, Layout, Menu, theme, Tooltip } from 'antd';

import Logo2 from "assets/images/logo_final_0.png";
import LogoWithText from "assets/logo/flowHrWithText.png";
import cx from "classnames";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Company from "./Company";
import styles from "./MainLayout2.module.css";
// import "./MainLayoutCommon.module.css";
import { Footer } from 'antd/es/layout/layout';
import { ReactComponent as SettingIcon } from "assets/icon/companySetting.svg";
import { ReactComponent as DashboardIcon } from "assets/icon/dashboardIcon.svg";
import { ReactComponent as DocumentIcon } from "assets/icon/documentIcon.svg";
import { ReactComponent as EmployeeIcon } from "assets/icon/employeeIcon.svg";
import { ReactComponent as ExpenseIcon } from "assets/icon/expenseIcon.svg";
import { ReactComponent as HomeIcon } from "assets/icon/homeIcon.svg";
import { ReactComponent as LefArrow } from "assets/icon/leftArrow.svg";
import { ReactComponent as ReportIcon } from "assets/icon/line_chart_up.svg";
import { ReactComponent as LoanIcon } from "assets/icon/loanIcon.svg";
import { ReactComponent as MasterDataIcon } from "assets/icon/masterData.svg";
import { ReactComponent as NotificationIcon } from "assets/icon/notificationIcon.svg";
import { ReactComponent as PermissionIcon } from "assets/icon/permissionIcon.svg";
import { ReactComponent as RightArrow } from "assets/icon/rightArrow.svg";
import { ReactComponent as TeamIcon } from "assets/icon/teamIcon.svg";
import { ReactComponent as SettingTimeSheetIcon } from "assets/icon/settingTimesheet.svg";
import { ReactComponent as WalletIcon } from "assets/icon/walletIcon.svg";
import { LanguageSwitcher } from 'components/elements';
import Notification from "./Notification";
import User from "./User";
import { setCollapsed, setCollapsedHead } from './slices/mainSlice';
import useCompany from 'features/company/hooks/useCompany';
import * as services from "./services/MainLayoutApi";
import { setIsLoading, setProfile } from 'features/authentication/slices/loginSlice';

const { Header, Sider, Content } = Layout;

const MainLayout = ({
  className = "",
  title = "-",
  headerContent = null,
  breadcrumb = [],
  children,
}) => {
  // const [collapsed, setCollapsed] = useState(false);
  const dispatch = useDispatch();
  const { collapsed, collapsedHead } = useSelector((state) => state.main);
  const { roles } = useSelector((state) => state.company);
  const { getNotificationBadge } = useCompany()
  const { token: { borderRadiusLG },
  } = theme.useToken();
  const { t } = useTranslation();
  const profile = useSelector((state) => state.login.profile);

  function getItem(rules, i18n_key, label, key, icon, children, type) {
    let list = [...roles]
    if (!list.includes(rules) && ("admin" != rules)) {
      return {}
    }
    const listNew = {
      i18n_key,
      key,
      icon,
      children,
      label,
      type,
    };
    return listNew
  }
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const [selectedKeys, setSelectedKeys] = useState(["home"]);
  const [openKeys, setOpenKeys] = useState(["home"]);

  const menuContainerRef = useRef(null);

  const getLevelKeys = (items1) => {
    const key = {};
    const func = (items2, level = 1) => {
      items2.forEach((item) => {
        if (item.key) {
          key[item.key] = level;
        }
        if (item.children) {
          func(item.children, level + 1);
        }
      });
    };
    func(items1);
    return key;
  };

  useEffect(() => {
    if (menuContainerRef.current && selectedKeys.length > 0) {
      const selectedItem = menuContainerRef.current.querySelector('.ant-menu-item-selected');
      if (selectedItem) {
        selectedItem.scrollIntoView({
          behavior: 'auto',
          block: 'nearest',
          inline: 'nearest'
        });
      }
    }
  }, [selectedKeys]);

  const MENU_LIST = [
    getItem("ACCESS_HOME", "home", "Home", "home", <HomeIcon />),
    getItem("ACCESS_DASHBOARD", "dashboard", "Dashboard", "dashboard", <DashboardIcon />),
    getItem("ACCESS_TEAM", "my_team", "My Team", "my_team", <TeamIcon />, [
      getItem("ACCESS_TEAM|WORK_SCHEDULE", "work_schedule", "Work Schedule", "my_team.work_schedule"),
      getItem("ACCESS_TEAM|CALENDAR", "workin_calendar", "Workin Calendar", "my_team.workin_calendar"),
      getItem("ACCESS_TEAM|LEAVE_CALENDAR", "leave_calendar", "Leave Calendar", "my_team.leave_calendar"),
      getItem("ACCESS_TEAM|SUB_ORDINATES", "subordinate", "Subordinates", "my_team.subordinate")
    ]),
    getItem("ACCESS_TIMESHEET", "timesheet", "Timesheet", "timesheet", <SettingTimeSheetIcon />, [
      getItem("ACCESS_TIMESHEET|MY_TIMESHEET", "my_timesheet", "My timesheet", "timesheet.my_timesheet"),
      getItem("ACCESS_TIMESHEET|MY_TEAM", "team_timesheet", "My team", "timesheet.my_team"),
    ]),

    getItem("ACCESS_MY_DOCUMENT", "document_request", "My Document", "my_document", <DocumentIcon />, [
      getItem("ACCESS_MY_DOCUMENT|MY_REQUEST", "my_request", "My Request", "my_document.my_request", ""),
      getItem("ACCESS_MY_DOCUMENT|REQUEST_APPROVAL_LIST", "request_approval", "Request Approval", "my_document.request_approval",),
      getItem("ACCESS_MY_DOCUMENT|WARNING_LETTER", "warning_letter", "Warning Letter", "my_document.warning_letter",),
    ]),
    getItem("ACCESS_EMPLOYEE", "employee", "Employee", "employee", <EmployeeIcon />),
    getItem("ACCESS_PAYROLL", "payroll", "Payroll", "payroll", <ExpenseIcon />
      // [
      //   getItem("ACCESS_PAYROLL|PAYMENT_PERIOD", "payment_period", "Payroll", "payroll.payment_period"),
      //   getItem("ACCESS_PAYROLL|EMPLOYMENT_TYPE", "payroll.employment_type_setup", "Payroll", "payroll.employment_type_setup"),
      //   getItem("ACCESS_PAYROLL|INCOME", "income", "Income", "payroll.income"),
      //   getItem("ACCESS_PAYROLL|DEDUCTION", "deduction", "Deduction", "payroll.deduction"),
      //   getItem("ACCESS_PAYROLL|WELFARE", "welfare", "Welfare", "payroll.welfare"),
      // ]
    ),
    getItem("ACCESS_EXPENSE", "expense", "Expense", "expense", <WalletIcon />),

    getItem("ACCESS_WELFARE_LOAN", "welfare_loan", "Welfare Loan", "becash", <LoanIcon />),
    getItem("ACCESS_REPORT", "report", "Report", "report", <ReportIcon />,
      [
        getItem("ACCESS_REPORT|EMPLOYEE_HISTORY_GROUP", "employee_history_group", "Employee History Group", "report.employee_history_group", null,
          [
            getItem("ACCESS_REPORT|EMPLOYEE_HISTORY_GROUP|EMPLOYEE_REGISTRATION_REPORT", "employee_registration_report", "Employee registration report", "report.employee_history_group.employee_registration_report"),
            getItem("ACCESS_REPORT|EMPLOYEE_HISTORY_GROUP", "employee_register_under_labour_report", "Employee Register under the Labour Act Report", "report.employee_history_group.employee_register_under_labour_act_report"),
            getItem("ACCESS_REPORT|EMPLOYEE_HISTORY_GROUP|EMPLOYEE_WARNING_LETTER", "employee_warning_letter", "Warning Letter", "report.employee_history_group.employee_warning_letter"),
            getItem("ACCESS_REPORT|EMPLOYEE_HISTORY_GROUP|TERMINATE_SSO_REPORT", "terminate_social_security_report", "Termination of the Social Security Fund", "report.employee_history_group.terminate_social_security_report"),
          ]
        ),

        getItem("ACCESS_REPORT|SALARY_CALCULATION_GROUP", "salary_calculation_group", "Salary Calculation Group", "report.salary_calculation_group", null,
          [
            // getItem("ROLE_HR", "report_on_the_results_of_calculation_not_salary_for_regular_periods", "Salary Calculation Group", "report.salary_calculation_group.salary_calculation_normal_period")
            getItem("ACCESS_REPORT|SALARY_CALCULATION_GROUP|EMPLOYEE_PAYROLL_REPORT", "employee_payroll_report", "Employee Payroll Report", "report.salary_calculation_group.employee_payroll_report"),
            getItem("ACCESS_REPORT|SALARY_CALCULATION_GROUP|SECTION_50BIS_REPORT", "section_50bis_report", "Section 50Bis Report", "report.salary_calculation_group.section_50bis_report"),
            getItem("ACCESS_REPORT|SALARY_CALCULATION_GROUP|PND1_REPORT", "pnd_1", "P.N.D. 1 Report", "report.salary_calculation_group.pnd1"),
            getItem("ACCESS_REPORT|SALARY_CALCULATION_GROUP|PND1_KOR_REPORT", "pnd_1_kor", "P.N.D. 1 Kor Report", "report.salary_calculation_group.pnd1kor"),
            getItem("ACCESS_REPORT|SALARY_CALCULATION_GROUP|ANNUAL_PND_1_REPORT", "annual_pnd", "Annual P.N.D. Report", "report.salary_calculation_group.annual_pnd_1"),
            getItem("ACCESS_REPORT|SALARY_CALCULATION_GROUP|PND3_REPORT", "pnd_3", "P.N.D. 3 Report", "report.salary_calculation_group.pnd3"),
            getItem("ACCESS_REPORT|SALARY_CALCULATION_GROUP|SSO_PAYMENT_REPORT", "sso_payment", "Social Security Payment Report", "report.salary_calculation_group.sso_payment"),
            getItem("ACCESS_REPORT|SALARY_CALCULATION_GROUP|FUND_REPORT", "fund_report", "Fund Report", "report.salary_calculation_group.fund_report"),
          ]
        ),

        getItem("ACCESS_REPORT|WORKING_TIME_GROUP", "working_time_group", "Working Time Group", "report.working_time_group", null,
          [
            getItem("ACCESS_REPORT|WORKING_TIME_GROUP|TIME_STAMP_REPORT", "time_stamp_report", "Timestamp", "report.working_time_group.time_stamp"),
            getItem("ACCESS_REPORT|WORKING_TIME_GROUP|ATTENDANCE_SUMMARY_REPORT", "Absence_report", "Absence Report", "report.working_time_group.absence"),
            getItem("ACCESS_REPORT|WORKING_TIME_GROUP|OVERTIME_REPORT", "overtime_report", "Overtime Report", "report.working_time_group.overtime_report"),

            // getItem("ROLE_HR", "work_in_report", "Workin", "report.working_time_group.work_in")
          ]
        ),

        // hind ไว้ก่อน รอ required ชัด

        getItem("ACCESS_REPORT|LEAVE_RIGHTS_GROUP", "leave_rights_group", "Leave Rights Group", "report.leave_rights_group", null,
          [
            getItem("ACCESS_REPORT|LEAVE_RIGHTS_GROUP|FAREWELL_REPORT", "report_leave_rights", "Leave Rights", "report.leave_rights_group.leave_rights")
          ]
        ),

        getItem("ACCESS_REPORT|EXPENSE_GROUP", "expense_group", "Expense Group", "report.expense_group", null,
          [
            getItem("ACCESS_REPORT|EXPENSE_GROUP|EXPENSE_REPORT", "expense_report", "Expense Report", "report.expense_group.expense"),
          ]
        ),
      ]
    ),

  ];

  const SETTING_MENU_LIST = [
    getItem(
      "ACCESS_USER_MANAGEMENT",
      "user_management",
      "User Management",
      "user_management",
      <PermissionIcon style={{}} />,
      // [
      //   getItem("ACCESS_USER_MANAGEMENT|USER_LIST", "user_list", "User List", "user_management.user_list"),
      //   getItem("ACCESS_USER_MANAGEMENT|ROLE", "role", "Role", "user_management.role"),
      //   getItem("ACCESS_USER_MANAGEMENT|PERMISSION", "permission", "Permission", "user_management.permission"),
      // getItem("ACCESS_USER_MANAGEMENT|PAYROLL_PERMISSION",
      //   "payroll_permission",
      //   "Payroll Permission",
      //   "user_management.payroll_permission"
      // ),
      // ]
    ),
    getItem("ACCESS_NEWS_&_POLICY", "news_policy", "News & Policy", "news_policy", <NotificationIcon />, [
      getItem("ACCESS_NEWS_&_POLICY|NEWS", "news", "News", "news_policy.news"),
      getItem("ACCESS_NEWS_&_POLICY|POLICY", "policy", "Policy", "news_policy.policy"),
    ]),
    getItem("ACCESS_CONFIGURATION", "configuration", "Configuration", "configuration", <SettingIcon />, [
      getItem("ACCESS_CONFIGURATION|COMPANY_SETTING", "company_setting", "Company Setting", "configuration.company"),
      getItem("ACCESS_CONFIGURATION|ATTENDANCE_SETTING", "attendance_setting", "Attendance Setting", "configuration.attendance"),
      getItem("ACCESS_CONFIGURATION|PAYROLL_SETTING", "payroll_setting", "Payroll Setting", "configuration.payroll"),
      getItem("ACCESS_CONFIGURATION|PRODUCT_SETTING", "product", "product", "configuration.product"),
      getItem("ACCESS_CONFIGURATION|WHITE_LIST", "whitelist", "White list", "configuration.whitelist"),
      // getItem("ACCESS_CONFIGURATION|PAYROLL_SETTING", "welfare_loan", "Welfare Loan", "configuration.becash"),
    ]),
    getItem("ACCESS_MASTER_DATA_LIST", "masterdata", "Master Data", "masterdata", <MasterDataIcon />, [
      getItem("ACCESS_MASTER_DATA_LIST|MASTER_DATA", "masterdata", "Master Data", "masterdata.master_data"),
      getItem("ACCESS_MASTER_DATA_LIST|SOCIAL_SECURITY_CONTRIBUTION", "social_security_contribution", "Social Security Contribution", "masterdata.social_security_contribution"),
      // getItem("ACCESS_MASTER_DATA_LIST|NOTIFICATION_TEMPLATE", "notification_template", "Notification Template", "masterdata.notification_template"),  //รอเปิด
      getItem("ACCESS_MASTER_DATA_LIST|YEAR_TO_DATE_EARNING", "year-to-date_earning", "Year-to-date Earning", "masterdata.year-to-date_earning"),
      getItem("ACCESS_MASTER_DATA_LIST|ACCOUNT_CATEGORY", "account_category", "Account Category", "masterdata.account_category"),
      getItem("ACCESS_MASTER_DATA_LIST|NOTIFICATION_SETTING", "notification_setting", "Setting Email Template", "masterdata.setting_email_template"),
      // getItem("ACCESS_MASTER_DATA_LIST|SETTING_EMAIL_NOTIFICATION", "setting_notification", "Setting notification", "masterdata.setting_notification"),
      getItem("ACCESS_MASTER_DATA_LIST|SMTP_SETTINGS", "mail", "Mail", "masterdata.configuration_mail"),
      getItem("ACCESS_MASTER_DATA_LIST|IMPORT_DATA", "import_data", "Import Data", "masterdata.import_data"),

    ]),
    getItem("ACCESS_SETTING_TIMESHEET", "setting_timesheet", "Setting Timesheet", "setting_timesheet", <SettingTimeSheetIcon />,
      [
        getItem("ACCESS_SETTING_TIMESHEET|SETTING_PROJECT", "setting_project", "Setting Project", "setting_timesheet.setting_project"),
        getItem("ACCESS_SETTING_TIMESHEET|MASTER_DATA", "masterdata", "Master Data", "setting_timesheet.masterdata")
      ]
    )
  ];

  const ADMIN_MENU = [
    getItem("admin", "response_company", "Responsible Company", "admin.response_company", <HomeIcon />),
    getItem("admin", "admin_setting", "Admin Setting ", "admin.admin_setting", <HomeIcon />),
    getItem("admin", "admin_campaigns_promotions", "Campaings & Promotions ", "admin.admin_campaigns_promotions", <HomeIcon />)
  ];



  const levelKeys = getLevelKeys([...MENU_LIST, ...SETTING_MENU_LIST]);
  // console.log("levelKeys", levelKeys);

  const onOpenChange = (param) => {
    // console.log("param currentOpenKey", param);

    const currentOpenKey = param.find((key) => openKeys.indexOf(key) === -1);
    // open

    if (currentOpenKey !== undefined) {
      const repeatIndex = openKeys
        .filter((key) => key !== currentOpenKey)
        .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);
      setOpenKeys(
        param
          // remove repeat key
          .filter((_, index) => index !== repeatIndex)
          // remove current level all child
          .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey]),
      );
    } else {
      // close
      setOpenKeys(param);
    }
  };

  function modifyKeys(keys = []) {
    // console.log("keys", keys);

    return keys.map((k, idx) => {
      if (idx === 0) return k;
      if (idx - 1 > 0) return keys[idx - 2] + "." + keys[idx - 1] + "." + k;
      return keys[idx - 1] + "." + k;
    });
  }

  useMemo(() => {
    const pathname = location.pathname;
    // console.log("pathname", pathname);
    // console.log("collapsed", collapsed);

    if (pathname === "/") {
      setSelectedKeys(["home"]);
      setOpenKeys(["home"]);
    } else {
      const splitedKey = pathname.split("/");
      const clonedKeys = [...splitedKey];
      clonedKeys.shift();
      // console.log("clonedKeys", clonedKeys);
      const modifiedKeys = modifyKeys(clonedKeys);

      if (!collapsed) {
        setOpenKeys(modifiedKeys);
      }
      // console.log("modifiedKeys", modifiedKeys);

      setSelectedKeys(modifiedKeys);
    }

  }, [location.pathname, collapsed]);

  const onMenuClick = (e) => {
    let link = "";
    if (e.key === "home") {
      link = "/";
    } else {
      const splitedKey = e.key.split(".");
      setOpenKeys([splitedKey[0]]);
      const joinedKey = splitedKey.join("/");
      link = "/" + joinedKey;
    }
    navigate(link);

    setTimeout(() => {
      const selectedItem = menuContainerRef.current?.querySelector('.ant-menu-item-selected');
      if (selectedItem) {
        selectedItem.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      }
    }, 100);
  };

  const isDesktopOrLaptop = useMediaQuery({ minWidth: 1224 })
  // const isBigScreen = useMediaQuery({ minWidth: 1824 })
  // const isTabletOrMobile = useMediaQuery({ maxWidth: 1224 })
  // const isPortrait = useMediaQuery({ orientation: 'portrait' })
  // const isRetina = useMediaQuery({ minResolution: '2dppx' })
  useEffect(() => {
    if (!isDesktopOrLaptop) {
      dispatch(setCollapsed(true))
    }
  }, [isDesktopOrLaptop])

  const extractKeys = (menuList) => {
    const keys = new Set();
    const recursiveExtractKeys = (menu) => {
      menu.forEach((item) => {
        if (item?.key) keys.add(item.key);
        if (Array.isArray(item?.children)) recursiveExtractKeys(item.children);
      });
    };

    recursiveExtractKeys(menuList);
    return Array.from(keys);
  };

  const hideResponse = useMemo(() => {
    if (isDesktopOrLaptop || collapsedHead == false) {
      return {}
    } else {
      // dispatch(setCollapsedHead(false))
      return { display: 'none' }
    }
  }, [isDesktopOrLaptop, collapsedHead])
  const hideResponseHead = useMemo(() => {
    if (!isDesktopOrLaptop && collapsedHead) {
      return {}
    } else {
      return { display: 'none' }
    }
  }, [isDesktopOrLaptop, collapsedHead])

  const [color, setColor] = useState({
    bgColor1: "#2bacdd",
    bgColor2: "#00d4cf",
  })


  const bgMain = () => {
    return (
      `
      <svg width="1920" height="828" viewBox="0 0 1920 828" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1231_1423)">
        <rect width="1920" height="827.43" fill="#EFF2F5"/>
        <path d="M0 0H1932.59C1932.59 0 2074.08 290.456 1890.35 327.536C1763.01 353.235 1671.15 280.736 1529.7 290.456C1426.06 297.578 1374.67 343.896 1270.71 341.467C1177.74 339.294 1133.75 292.465 1040.77 290.456C937.724 288.229 887.287 341.839 784.204 341.467C682.959 341.102 594.301 291.346 493.059 290.456C387.224 289.526 281.499 341.119 175.658 341.467C67.9842 341.821 0 290.456 0 290.456V0Z" fill="url(#paint0_linear_1231_1423)" fill-opacity="0.8"/>
        </g>
        <defs>
        <linearGradient id="paint0_linear_1231_1423" x1="25.4941" y1="28.1949" x2="1828.7" y2="377.528" gradientUnits="userSpaceOnUse">
        <stop stop-color="${color.bgColor1}"/>
        <stop offset="1" stop-color="${color.bgColor2}"/>
        </linearGradient>
        <clipPath id="clip0_1231_1423">
        <rect width="1920" height="827.43" fill="white"/>
        </clipPath>
        </defs>
      </svg>
      `
    );
  };

  const getAdminDetailsFromToken = useCallback(
    async () => {
      try {
        dispatch(setIsLoading(true));
        const response = await services.getAdminDetails();
        console.log("response", response);
        if (response?.data?.content)
          dispatch(setProfile(response?.data?.content));
      } catch (error) {
        // alert({
        //   type: "error",
        //   message: "Get company failed, Redirect Back to signin page.",
        //   resultObject: error,
        // });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    []
  );

  useEffect(() => {
    if (!profile) {
      getAdminDetailsFromToken();
    }
  }, [profile, getAdminDetailsFromToken]);

  const svgToDataUrl = (svgString) => {
    return `data:image/svg+xml;base64,${btoa(svgString)}`;
  }

  // รวม MENU_LIST และ SETTING_MENU_LIST
  const combinedMenu = [...MENU_LIST, ...SETTING_MENU_LIST];

  // ดึง key ทั้งหมดจากเมนูที่รวมกัน
  // const allMenuKeys = extractKeys(combinedMenu);

  // useEffect(() => {
  //   if (!allMenuKeys || allMenuKeys.length === 0) {
  //     // console.log("Waiting for all data to load...");
  //     return;
  //   }
  //   if (!location?.pathname) return;

  //   let lastIndex = 0;
  //   let lastKey = openKeys[lastIndex] ?? "";
  //   const checkHave = allMenuKeys.includes(lastKey);

  //   if (!checkHave && lastKey !== 'profile' && lastKey !== 'logout') {
  //     // console.log("Navigating to '/' due to invalid lastKey:", lastKey);
  //     navigate("/");
  //   } else {
  //     // console.log("Navigating to ", lastKey);
  //   }
  // }, [location.pathname, allMenuKeys]);



  // console.log("window.innerWidth", window.innerWidth);
  // useEffect(() => console.log("window.innerWidth", window.innerHeight, window.length, window.innerWidth), [window.innerHeight, window.length, window.innerWidth])
  return (
    <Layout
      // className={cx(
      //   styles.container,
      //   className
      // )}
      hasSider={true}
      style={{
        // backgroundImage: `url(${svgToDataUrl(bgMain())})`,
        backgroundColor: '#FCFCFC',
        backgroundSize: "100vw",
        backgroundRepeat: "no-repeat",
        maxWidth: "100%"
        // justifyContent: "center",
        // alignItems: "center"
      }}
    >
      <Sider
        theme='light'
        width="250px"
        className={cx(styles.sidebar)}
        style={{
          padding: "30px 24px",
          position: "sticky",
          overflow: "visible",
          // borderRadius: "0 2rem 0 0",
          maxHeight: "80%",
          // backgroundColor: "#f1f7fd",
          ...hideResponse,
          zIndex: 11
          // alignSelf: "self-end",
          // display: 'none'
          // top: 0,
          // left: 0,
          // // width: 400px;
          // height: "100%"
          // width: "1000vh"
          // height: 1000
        }}
        trigger={null} collapsible collapsed={collapsed}>
        <Button
          icon={collapsed ? <RightArrow /> : <LefArrow />}
          onClick={() => {
            if (isDesktopOrLaptop) {
              dispatch(setCollapsed(!collapsed))
            } else {
              dispatch(setCollapsedHead(!collapsedHead))
            }
          }}
          style={{
            fontSize: '16px',
            width: 28,
            height: 28,
            position: "absolute",
            top: 55,
            right: -15,
            zIndex: 12,
            color: "#667085",
            padding: 6,
            borderRadius: 8,
            borderColor: "#F6F6F6",
            boxShadow: "none"
          }}
        />

        {collapsed
          ? <Image preview={false} src={Logo2} className={styles.logo} alt='flow hr logo' />
          : <Flex justify='center'>
            <Image preview={false} src={LogoWithText} alt='flow hr logo with text' width={150} />
          </Flex>
        }
        <Divider className={styles.dividerCustom} />
        <Flex
          vertical
          ref={menuContainerRef}
          style={{
            maxHeight: "80%",
            overflow: "auto",
            scrollbarWidth: "none",
            scrollBehavior: "smooth"
          }}
        >
          {(profile?.adminType == "SUPER_ADMIN" && profile?.isAdminEndpoint == "Y" && pathname.includes("admin")) ?
            <Menu
              className={styles.menu}
              defaultSelectedKeys={["response_company"]}
              mode="inline"
              selectedKeys={selectedKeys}
              openKeys={openKeys}
              items={ADMIN_MENU?.filter(o => o.key != null)?.map((entity) => {
                return {
                  ...entity,
                  label: (<Tooltip title={t(`${entity.i18n_key}.header`)} placement="right">
                    <span>{t(`${entity.i18n_key}.header`)}</span>
                  </Tooltip>),
                  children:
                    entity.children?.filter(o => o.key != null)?.map((child) => {
                      return {
                        ...child,
                        label: (<Tooltip title={t(`${child.i18n_key}.header`)} placement="right">
                          <span>{t(`${child.i18n_key}.header`)}</span>
                        </Tooltip>),
                        children:
                          child.children?.filter(o => o.key != null)?.map((subChild) => {
                            return {
                              ...subChild,
                              label: (<Tooltip title={t(`${subChild.i18n_key}.header`)} placement="right">
                                <span>{t(`${subChild.i18n_key}.header`)}</span>
                              </Tooltip>),
                            };
                          }) || child.children,
                      };
                    }) || entity.children,
                };
              })}
              onClick={onMenuClick}
              onOpenChange={onOpenChange}
            // inlineCollapsed={collapsed}
            />
            : (
              <div>
                <Menu
                  className={styles.menu}
                  defaultSelectedKeys={["home"]}
                  mode="inline"
                  selectedKeys={selectedKeys}
                  openKeys={openKeys}
                  items={[
                    ...MENU_LIST?.filter(o => o.key != null)?.map((entity) => ({
                      ...entity,
                      label: (<Tooltip title={t(`${entity.i18n_key}.header`)} placement="right">
                        <span>{t(`${entity.i18n_key}.header`)}</span>
                      </Tooltip>),
                      children: entity.children?.filter(o => o.key != null)?.map((child) => ({
                        ...child,
                        label: (<Tooltip title={t(`${child.i18n_key}.header`)} placement="right">
                          <span>{t(`${child.i18n_key}.header`)}</span>
                        </Tooltip>),
                        children: child.children?.filter(o => o.key != null)?.map((subChild) => ({
                          ...subChild,
                          label: (<Tooltip title={t(`${subChild.i18n_key}.header`)} placement="right">
                            <span>{t(`${subChild.i18n_key}.header`)}</span>
                          </Tooltip>),
                        })) || child.children,
                      })) || entity.children,
                    })),

                    { type: 'divider' },

                    {
                      type: 'group',
                      label: <span style={{ color: "#757575", fontSize: "12px" }}>{t("common.setting")}</span>,
                      children: SETTING_MENU_LIST?.filter(o => o.key != null)?.map((entity) => ({
                        ...entity,
                        label: (<Tooltip title={t(`${entity.i18n_key}.header`)} placement="right">
                          <span>{t(`${entity.i18n_key}.header`)}</span>
                        </Tooltip>),
                        children: entity.children?.filter(o => o.key != null)?.map((child) => ({
                          ...child,
                          label: (<Tooltip title={t(`${child.i18n_key}.header`)} placement="right">
                            <span>{t(`${child.i18n_key}.header`)}</span>
                          </Tooltip>),
                        })) || entity.children,
                      })),
                    }
                  ]}
                  onClick={onMenuClick}
                  onOpenChange={onOpenChange}
                // inlineCollapsed={collapsed}
                />

                {/* <Divider className={styles.dividerCustom} />
                <span style={{ color: "#757575", fontSize: "12px" }}>{t("common.setting")}</span>

                <Menu
                  className={styles.menu}
                  mode="inline"
                  selectedKeys={selectedKeys}
                  openKeys={openKeys}
                  items={SETTING_MENU_LIST?.filter(o => o.key != null)?.map((entity) => {
                    return {
                      ...entity,
                      label: (<Tooltip title={t(`${entity.i18n_key}.header`)} placement="right">
                        <span>{t(`${entity.i18n_key}.header`)}</span>
                      </Tooltip>),
                      children:
                        entity.children?.filter(o => o.key != null)?.map((child) => {
                          return {
                            ...child,
                            label: (<Tooltip title={t(`${child.i18n_key}.header`)} placement="right">
                              <span>{t(`${child.i18n_key}.header`)}</span>
                            </Tooltip>),
                          };
                        }) || entity.children,
                    };
                  })}
                  onClick={onMenuClick}
                  onOpenChange={onOpenChange}
                /> */}
              </div>
            )
          }
        </Flex>

        {/* <Flex style={{
          height: "15%"
        }} justify='center'> */}
        <Flex justify='center' style={{ marginTop: "2vh" }}>
          <span style={{ color: "#757575" }}>{t("common.version")} 1.3.4</span>
        </Flex>
      </Sider>
      <Layout style={{
        backgroundColor: 'transparent',
      }} >
        <Header
          className={styles.header}
          style={{
            // paddingTop: "10px",
            paddingLeft: 0,
            paddingRight: 0,
            zIndex: 10
            // marginLeft: '8px',
            // backgroundColor: "red",
            // lineHeight: "20px",
            // borderRadius: borderRadiusLG,
            // top: 10,
            // bottom: 100
            // display: "grid",
            // gridTemplateColumns: 'auto auto 20px'
          }}
        // scroll={{ x: 950, y: "calc(100vh - 220px)" }}
        >
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={() => dispatch(setCollapsedHead(!collapsedHead))}
            style={{
              fontSize: '16px',
              width: 50,
              height: 50,
              position: "fixed",
              // background: "#f1f7fd",
              color: "black",
              ...hideResponseHead
            }}
          />
          <Flex justify='space-between' align='center'>
            {(profile?.isAdminEndpoint === "Y" && !pathname.startsWith("/admin")) && (
              <Flex style={{ paddingLeft: "20px" }}>
                <Button
                  icon={<LeftOutlined />}
                  onClick={() => { navigate("/admin/response_company") }}
                >
                  {t("common.back")}
                </Button>
              </Flex>
            )}

            {headerContent && (
              <Flex align="center" style={{ paddingLeft: "20px" }}>
                {headerContent}
              </Flex>
            )}

            <Flex
              justify='end'
              style={{ flex: 1 }}
            >

              {/* <Row align="middle" justify="space-between" > */}
              {/* <Space size="1" direction='vertical'> */}
              {/* <Flex style={{
              lineHeight: '20px',
              paddingTop: "20px",
              paddingLeft: "20px"
            }} vertical={true} gap={1}>
              <Breadcrumb breadcrumb={breadcrumb} /> */}
              {/* <div className={styles.title}
                style={{}}> */}
              {/* <h2>{title}</h2> */}
              {/* </div> */}

              {/* </Flex> */}
              {/* </Space> */}
              {/* </Row> */}

              <Flex justify='center' align='center' gap={10} style={{
                paddingTop: 10,
                paddingRight: 20,
              }}>
                {((pathname.startsWith("/admin/response_company/")) || !pathname.startsWith("/admin")) && (
                  <Flex
                    justify="center"
                    align="center"
                    style={{
                      paddingTop: 10,
                      marginRight: "10px",
                      paddingLeft: 10,
                      backgroundColor: "#ffffff",
                      borderRadius: 10,
                      height: 50,
                      paddingBottom: 10,
                      border: "2px solid #f6f6f6",
                    }}
                  >
                    <Company />
                  </Flex>
                )}

                <Flex gap={14} align='center'>
                  <LanguageSwitcher showDropdown={true} hideText={true} />
                  <Notification />
                  <User />
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </Header>
        <Content
          className={styles.content}
          style={{
            margin: '8px 8px',
            padding: '0.9%',
            // padding: 10,
            // minHeight: 280,
            // width: "100%",
            borderRadius: borderRadiusLG,
            backgroundColor: 'transparent',
            // position: 'sticky'
          }}
        >
          <div className={styles.body}>
            <div style={{
              // position: 'relative',
              // overflow: 'auto'
              // height: "max-content",
              backgroundColor: 'transparent',
              paddingRight: "1vw",
            }}
            // scroll={{ x: 950, y: "calc(100vh - 220px)" }}
            >{children}
            </div>
          </div>
        </Content>
        <Footer style={{ backgroundColor: "transparent" }}>
          <Flex justify='center'>
            <span style={{ color: "#757575" }}>
              Copyright (c) by Bright Expert Company Limited. All Rights Reserved.
            </span>
          </Flex>
        </Footer>
      </Layout>
    </Layout >
  );
};
export default MainLayout;